import styled from "@emotion/styled";
import { css } from "@emotion/react";
import {
  colors,
  customEvent,
  GoiLogo,
  GOI_PLATFORM_URL,
  HStack,
  responsive,
  VStack,
} from "goi_common";

import { HeaderNav } from "@/components/HeaderNav";
import { HEADER_HEIGHT } from "@/constants/layout";

/**
 * 홈 헤더. ParlorHeader 와 마크업이 다르지만 Nav 행은 같은 것을 쓴다.
 * 홈에서도 장례식장, 장지 인덱스로 갈 수 있어야 한다.
 *
 * Nav 를 넣으면 헤더가 HEADER_NAV_HEIGHT 만큼 높아진다. 이 헤더는 position:fixed
 * 라서 본문을 밀지 않으므로, 홈의 상단 여백(pages/index.tsx)도 함께 올려야 한다.
 */
export const GoiHeader = () => {
  return (
    <VStack css={headerCss({ isHomeViewportTop: false, isHome: false })}>
      <HStack
        css={responsive({
          width: "100%",
          height: HEADER_HEIGHT,
          padding: {
            base: "0px 20px",
            lg: "0px 120px",
          },
          maxWidth: {
            base: "480px",
            lg: "none",
          },
        })}
        justifyContent="space-between"
        alignItems="center"
      >
        <GoiLogo color="black" />
        <ConsultButton
          onClick={() => {
            customEvent({
              newGtm: {
                path: "prlr_home",
                trigger_and_target: "header-uv_mtch_rqst",
              },
            });
            window.location.href = `${GOI_PLATFORM_URL}/match/request/?utm_campaign=parlor`;
          }}
        >
          무료 상담
        </ConsultButton>
      </HStack>

      <HeaderNav variant="home" />
    </VStack>
  );
};

const ConsultButton = styled.button`
  padding: 7px 16px;
  border-radius: 6px;
  background: ${colors.orange650};
  color: ${colors.white};
  font-size: 13px;
  font-weight: 600;
  border: none;
  cursor: pointer;

  &:hover {
    background: ${colors.orange700};
  }
`;

const headerCss = ({
  isHomeViewportTop,
  isHome,
}: {
  isHomeViewportTop: boolean;
  isHome: boolean;
}) =>
  css({
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
    position: "fixed",
    width: "100%",
    top: "0",
    backgroundColor: isHomeViewportTop ? `transparent` : colors.white,
    transition: isHome ? "background-color 0.1s linear" : "none",
    zIndex: "1000",
    userSelect: "none",
  });
